export default __webpack_public_path__ + "static/media/IMG_5013.77e9e5ab.jpeg";